import AlertRequestQuery from "~/entities/AlertRequestQuery";
import ValidationModule from "~/entities/ValidationModule";

export default class ValidationContents extends ValidationModule {
  public descriptionsAlerts = {
    selector: {
      outside: "OutsideDescriptionShort",
      inside: "InsideDescriptionShort",
    },
    needle: [""],
  };
  public ordersAlerts = {
    selector: {
      failedSave: "AlertUnableToSaveOrder",
      blocked: "AlertAccountBlocked",
    },
    needle: [""],
  };
  public invalidOutsideDescriptions = [[false]] as any;
  public invalidInsideDescriptions = [[false]] as any;

  public constructor() {
    super("Contents");
    this.alertNames = [
      "AlertInvalidFromCountry", //We do not currently offer shipping services from #CountryName#
      "AlertInvalidCountry", //We do not currently offer shipping services to #CountryName#.
      "MultiplePackageHighValue", //Some of the packages in your shipment qualify for Preferred Handling. To ensure the whole shipment receives the same service level, we suggest you select Protection levels for each that include Preferred Handling.
      "AlertPostalCodeLookup", //Unable to lookup your postal code right now, no problem though.
      "AlertEbikeShipment", //BikeFlights’ e-bike shipping program is for safely shipping single e-bikes that have their battery either contained within the frame or fully installed.
      "AlertEBikeInternational", //E-bike shipping is currently available via ground service within the contiguous U.S.
      "AlertFedExFailed", //We were not able to get rates from the information you provided. Typically the reason is that you gave us too much or too little detail. Try typing something as simple as a basic street address or a city, state, and zip code combination to get rates. Thank you.
      "AlertFedExCanadaNoResults", //Sorry! We were not able to get rates from the information you provided. Typically the reason is that you gave us too much or too little detail. Try typing something as simple as a basic street address or a city and state combination to get rates. Thank you.
      "AlertUnableToSaveOrder", //We were unable to save your order. You can try again or contact support.
      "ProtectionTooHigh", //You can't purchase more protection than the value of your bike..
      "ProtectionLTMarketValue", //The Premium Protection Plan selection you made was $#DIFF#USD less than the Market Value of your shipment. Per our <a href=\"https://www.bikeflights.com/shippingpolicy\">Shipping Policy</a>, you are responsible for this difference in the event that accidental loss or damage occurs during transit. We recommend that you purchase  Premium Protection for the Market Value of your shipment.
      "OutsideDescriptionShort", //Please describe the outside of your box or case, the color of the markings, and where you might have picked it up. Descriptions with more detail help us identify bikes that get off course and ensure on-time delivery.
      "InsideDescriptionShort", //Please describe your contents such as manufacturer, model, groupset, wheels, and serial number. Descriptions with more detail help us identify bikes that get off course and ensure on-time delivery.
      "AlertAccountBlocked", //Your order cannot be completed-Your account is currently suspended or you are shipping to a suspended account - please contact Support for further information.
    ];
    this.alertTypes = {
      order: this.ordersAlerts,
      description: this.descriptionsAlerts,
    };
  }

  public async Validate(scope: string = "") {
    //for later Validate needs some kind of flag to asks for a particular validation type, depth or scope. so that only that method is called
    this.resetValidations();
    let errors = 0;
    for (
      let stage = 0;
      stage < this.component?.boxesDescriptions.length;
      stage++
    ) {
      for (
        let step = 0;
        step < this.component?.boxesDescriptions[stage].length;
        step++
      ) {
        let outside =
          this.component?.boxesDescriptions[stage][step].outsideDescription;
        let inside =
          this.component?.boxesDescriptions[stage][step].insideDescription;
        if (
          (!outside && scope !== "description") ||
          (outside && !this.descriptionLength(2, outside))
        ) {
          errors++;
          this.validationErrors.push("outside-" + stage + "-" + step);
          this.invalidOutsideDescriptions[stage] = [];
          this.invalidOutsideDescriptions[stage][step] = true;
          this.requestAlert({ event: "outside", type: "description" });
        }
        if (
          (!inside && scope !== "description") ||
          (inside && !this.descriptionLength(3, inside))
        ) {
          errors++;
          this.validationErrors.push("inside-" + stage + "-" + step);
          this.invalidInsideDescriptions[stage] = [];
          this.invalidInsideDescriptions[stage][step] = true;
          this.requestAlert({ event: "inside", type: "description" });
        }
      }
    }
    if (scope !== "description") {
      if (errors == 0) {
        this.validated = true;
        this.validationMade = true;
      } else {
        this.validated = false;
        this.validationMade = true;
      }
    }
    return !errors;
  }
  public resetValidations() {
    this.validated = false;
    this.validationMade = false;
    this.validationErrors = [];
    this.invalidInsideDescriptions = [[false]];
    this.invalidOutsideDescriptions = [[false]];
    this.component?.clearActiveNotices();
  }
  public requestAlert(data: any) {
    this.component?.requestAlert(this.getFilteredAlertKey(data, "asObject"));
  }
  public addNotice(data: any) {
    this.component?.addNotice(this.getFilteredAlertKey(data));
  }
  public removeNotice(data: any) {
    this.component?.removeNotice(this.getFilteredAlertKey(data));
  }

  public descriptionLength(min: number, description: string): boolean {
    const space = description.trim().split(" ");
    const dash = description.trim().split("-");
    return space.length >= min || dash.length >= min;
  }

  protected getFilteredAlertKey(
    data: any,
    returnType: string = "asString"
  ): any {
    let keyGetter = new AlertRequestQuery();
    if (data.hasOwnProperty("type")) {
      let name = "";
      switch (data.type) {
        case "order":
          name = data.event;
          keyGetter.name = this.alertTypes[data.type].selector[name];
          keyGetter.typeSelector = name;
          break;
        case "description":
          name = data.event;
          keyGetter.name = this.alertTypes[data.type].selector[name];
          keyGetter.typeSelector = name;
          break;
      }
    } else {
      //fill
    }
    let filteredData = keyGetter.getKey(
      this.alertNames,
      this.alertTypes[data.type]
    );
    if (returnType == "asString") {
      return filteredData.name;
    } else {
      return filteredData;
    }
  }
}
